import { createSlice } from "@reduxjs/toolkit";
import { revertAll } from "../revertAll/RevertStateReducer";

const initialState = {
  // requests grouped by supplier: { [supplierName]: RequestItem[] }
  bySupplier: {},
  supplierOrder: [],
  supplierTotals: {},
  approvedBySupplier: {},
  pagination: { page: 1, pageSize: 10, totalItems: 0, totalPages: 1, totalRequests: 0, totalSuppliers: 0 },
  listLoading: false,
  listError: null,

  addLoading: false,
  addError: null,

  editLoading: false,
  editError: null,

  deleteLoading: false,
  deleteError: null,

  statusLoading: false,
  statusError: null,

  // request logs: { [requestId]: LogEntry[] }
  logsBySrequest: {},
  logsLoading: false,
  logsError: null,
  logAddLoading: false,
  logAddError: null,

  // purchase order number
  lastPoNum: 0,
  poNumLoading: false,
  poNumError: null,

  // lookups used by the filter/add/edit forms
  types: [],
  projects: [],
  userNames: [],
  maxValues: { unitSize: 0, numUnits: 0, unitPrice: 0 },
  lookupsLoading: false,
  lookupsError: null,
};

const requestSlice = createSlice({
  name: "request",
  initialState,
  extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
  reducers: {
    fetchRequestsStart(state) {
      state.listLoading = true;
      state.listError = null;
    },
    fetchRequestsSuccess(state, action) {
      state.listLoading = false;
      state.bySupplier = action.payload.bySupplier;
      state.supplierOrder = action.payload.supplierOrder;
      state.supplierTotals = action.payload.supplierTotals;
      state.approvedBySupplier = action.payload.approvedBySupplier;
      state.pagination = action.payload.pagination;
    },
    fetchRequestsFailure(state, action) {
      state.listLoading = false;
      state.listError = action.payload;
    },

    addRequestStart(state) {
      state.addLoading = true;
      state.addError = null;
    },
    addRequestSuccess(state) {
      state.addLoading = false;
    },
    addRequestFailure(state, action) {
      state.addLoading = false;
      state.addError = action.payload;
    },

    editRequestStart(state) {
      state.editLoading = true;
      state.editError = null;
    },
    editRequestSuccess(state) {
      state.editLoading = false;
    },
    editRequestFailure(state, action) {
      state.editLoading = false;
      state.editError = action.payload;
    },

    deleteRequestsStart(state) {
      state.deleteLoading = true;
      state.deleteError = null;
    },
    deleteRequestsSuccess(state) {
      state.deleteLoading = false;
    },
    deleteRequestsFailure(state, action) {
      state.deleteLoading = false;
      state.deleteError = action.payload;
    },

    updateStatusStart(state) {
      state.statusLoading = true;
      state.statusError = null;
    },
    updateStatusSuccess(state) {
      state.statusLoading = false;
    },
    updateStatusFailure(state, action) {
      state.statusLoading = false;
      state.statusError = action.payload;
    },

    fetchLogsStart(state) {
      state.logsLoading = true;
      state.logsError = null;
    },
    fetchLogsSuccess(state, action) {
      state.logsLoading = false;
      state.logsBySrequest[action.payload.requestId] = action.payload.logs;
    },
    fetchLogsFailure(state, action) {
      state.logsLoading = false;
      state.logsError = action.payload;
    },

    addLogStart(state) {
      state.logAddLoading = true;
      state.logAddError = null;
    },
    addLogSuccess(state) {
      state.logAddLoading = false;
    },
    addLogFailure(state, action) {
      state.logAddLoading = false;
      state.logAddError = action.payload;
    },

    fetchPoNumStart(state) {
      state.poNumLoading = true;
      state.poNumError = null;
    },
    fetchPoNumSuccess(state, action) {
      state.poNumLoading = false;
      state.lastPoNum = action.payload;
    },
    fetchPoNumFailure(state, action) {
      state.poNumLoading = false;
      state.poNumError = action.payload;
    },

    fetchLookupsStart(state) {
      state.lookupsLoading = true;
      state.lookupsError = null;
    },
    fetchLookupsSuccess(state, action) {
      state.lookupsLoading = false;
      state.types = action.payload.types;
      state.projects = action.payload.projects;
      state.userNames = action.payload.userNames;
      state.maxValues = action.payload.maxValues;
    },
    fetchLookupsFailure(state, action) {
      state.lookupsLoading = false;
      state.lookupsError = action.payload;
    },
  },
});

export const {
  fetchRequestsStart,
  fetchRequestsSuccess,
  fetchRequestsFailure,
  addRequestStart,
  addRequestSuccess,
  addRequestFailure,
  editRequestStart,
  editRequestSuccess,
  editRequestFailure,
  deleteRequestsStart,
  deleteRequestsSuccess,
  deleteRequestsFailure,
  updateStatusStart,
  updateStatusSuccess,
  updateStatusFailure,
  fetchLogsStart,
  fetchLogsSuccess,
  fetchLogsFailure,
  addLogStart,
  addLogSuccess,
  addLogFailure,
  fetchPoNumStart,
  fetchPoNumSuccess,
  fetchPoNumFailure,
  fetchLookupsStart,
  fetchLookupsSuccess,
  fetchLookupsFailure,
} = requestSlice.actions;

export default requestSlice.reducer;